// extracted by css-extract-rspack-plugin
export default {"moderationTestPage":"moderationTestPage__nP3he"};